<template>
  <div class="home-modern">

    <!-- ======================================================
         HERO SECTION
    ====================================================== -->
    <section class="hero-section">
      <div class="hero-bg-mesh"></div>
      <div class="hero-circle circle-1"></div>
      <div class="hero-circle circle-2"></div>
      <div class="hero-circle circle-3"></div>

      <div class="container-standar hero-content">
        <div class="row align-items-center">

          <!-- Left: Copy -->
          <div class="col-lg-6 col-md-12 hero-left" data-aos="fade-right">
            <span class="hero-eyebrow">Sistem Informasi Orang Asli Papua</span>
            <h1 class="hero-headline">
              Data &amp; Statistik<br />
              <span class="hero-headline-accent">Papua</span> Terpadu
            </h1>
            <p class="hero-body">
              Platform digital terpilah OAP dan Non‑OAP untuk mendukung
              perencanaan pembangunan berkelanjutan di seluruh kampung
              dan distrik Papua.
            </p>
            <div class="hero-actions">
              <a href="/data-pokok/data-kependudukan" class="btn-hero-primary">
                Lihat Data Pokok
                <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </a>
              <a href="/berita" class="btn-hero-ghost">Baca Berita</a>
            </div>
          </div>

          <!-- Right: Floating stat cards -->
          <div class="col-lg-6 col-md-12 hero-right">
            <div class="hero-cards-wrap">
              <div class="hero-stat-card hsc-1">
                <div class="hsc-icon">
                  <svg width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/>
                    <path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/>
                  </svg>
                </div>
                <div class="hsc-body">
                  <span class="hsc-num">{{ data_penduduk.jiwa.semua | convertToRupiah }}</span>
                  <span class="hsc-label">Total Jiwa</span>
                </div>
              </div>

              <div class="hero-stat-card hsc-2">
                <div class="hsc-icon hsc-icon-green">
                  <svg width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                    <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
                    <polyline points="9 22 9 12 15 12 15 22"/>
                  </svg>
                </div>
                <div class="hsc-body">
                  <span class="hsc-num">{{ data_penduduk.kartu_keluarga.semua | convertToRupiah }}</span>
                  <span class="hsc-label">Kepala Keluarga</span>
                </div>
              </div>

              <div class="hero-stat-card hsc-3">
                <div class="hsc-icon hsc-icon-orange">
                  <svg width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10"/>
                    <path d="M12 6v6l4 2"/>
                  </svg>
                </div>
                <div class="hsc-body">
                  <span class="hsc-num">{{ data_penduduk.jiwa.oap | convertToRupiah }}</span>
                  <span class="hsc-label">Jiwa OAP</span>
                </div>
              </div>

              <!-- Decorative map illustration -->
              <div class="hero-map-blob">
                <img src="@/assets/images/papua/icons/icon-service.svg" alt="" class="hero-map-img" />
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Bottom wave -->
      <div class="hero-wave-bottom">
        <svg viewBox="0 0 1440 90" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,40 C360,90 720,0 1080,50 C1260,75 1380,20 1440,40 L1440,90 L0,90 Z" fill="#ffffff"/>
        </svg>
      </div>
    </section>

    <!-- ======================================================
         QUICK STATS BAR
    ====================================================== -->
    <!-- <section class="stats-bar-section">
      <div class="container-standar">
        <div class="stats-bar-grid">

          <div class="stats-bar-item">
            <div class="sbi-icon sbi-blue">
              <svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/>
              </svg>
            </div>
            <div>
              <div class="sbi-num">{{ data_penduduk.pria.semua | convertToRupiah }}</div>
              <div class="sbi-desc">Laki-Laki</div>
            </div>
          </div>

          <div class="stats-bar-divider"></div>

          <div class="stats-bar-item">
            <div class="sbi-icon sbi-pink">
              <svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
              </svg>
            </div>
            <div>
              <div class="sbi-num">{{ data_penduduk.wanita.semua | convertToRupiah }}</div>
              <div class="sbi-desc">Perempuan</div>
            </div>
          </div>

          <div class="stats-bar-divider"></div>

          <div class="stats-bar-item">
            <div class="sbi-icon sbi-green">
              <svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>
              </svg>
            </div>
            <div>
              <div class="sbi-num">{{ data_penduduk.kartu_keluarga.semua | convertToRupiah }}</div>
              <div class="sbi-desc">Kartu Keluarga</div>
            </div>
          </div>

          <div class="stats-bar-divider"></div>

          <div class="stats-bar-item">
            <div class="sbi-icon sbi-orange">
              <svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/>
              </svg>
            </div>
            <div>
              <div class="sbi-num">{{ data_penduduk.jiwa.oap | convertToRupiah }}</div>
              <div class="sbi-desc">Jiwa OAP</div>
            </div>
          </div>

        </div>
      </div>
    </section> -->

    <!-- ======================================================
         JIWA SUMMARY + CHART SUMMARY (existing components)
    ====================================================== -->
    <div class="container-standar pb-5 pt-4">
      <JiwaSummary />
    </div>
    <div class="container-fluid bg-include height-res-tab-small-auto">
      <div class="container-standar">
        <ChartSummary />
      </div>
    </div>

    <!-- ======================================================
         SERVICES SECTION
    ====================================================== -->
    <section class="services-section section-modern">
      <div class="container-standar">
        <div class="section-head text-center">
          <span class="section-label">Layanan Kami</span>
          <h2 class="section-title mt-3">Fasilitas &amp; Layanan <span>SIO Papua</span></h2>
          <p class="section-subtitle">
            Platform terpadu untuk pengelolaan dan visualisasi data kependudukan Papua
            yang mendukung perencanaan pembangunan di tingkat kampung hingga provinsi.
          </p>
        </div>

        <div class="services-grid">

          <div class="service-card">
            <div class="sc-icon-wrap sc-blue">
              <svg width="26" height="26" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/>
              </svg>
            </div>
            <h4 class="sc-title">Data Kependudukan</h4>
            <p class="sc-desc">Data terpilah OAP dan Non-OAP untuk setiap kampung dan distrik di seluruh Papua.</p>
            <a href="/data-pokok/data-kependudukan" class="sc-link">Lihat Data →</a>
          </div>

          <div class="service-card">
            <div class="sc-icon-wrap sc-green">
              <svg width="26" height="26" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
              </svg>
            </div>
            <h4 class="sc-title">Data Kesehatan</h4>
            <p class="sc-desc">Informasi fasilitas kesehatan, sumber air minum, dan indikator kesehatan masyarakat.</p>
            <a href="/data-pokok/data-kesehatan" class="sc-link">Lihat Data →</a>
          </div>

          <div class="service-card">
            <div class="sc-icon-wrap sc-orange">
              <svg width="26" height="26" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/>
              </svg>
            </div>
            <h4 class="sc-title">Data Pendidikan</h4>
            <p class="sc-desc">Tingkat pendidikan, fasilitas sekolah, dan akses pendidikan di wilayah Papua.</p>
            <a href="/data-pokok/data-pendidikan" class="sc-link">Lihat Data →</a>
          </div>

          <div class="service-card">
            <div class="sc-icon-wrap sc-purple">
              <svg width="26" height="26" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path d="M1 6v16l7-4 8 4 7-4V2l-7 4-8-4-7 4z"/><path d="M8 2v16"/><path d="M16 6v16"/>
              </svg>
            </div>
            <h4 class="sc-title">Potensi Kampung</h4>
            <p class="sc-desc">Katalog potensi sumber daya alam dan ekonomi setiap kampung di Papua.</p>
            <a href="/potensi-kampung" class="sc-link">Lihat Data →</a>
          </div>

          <div class="service-card">
            <div class="sc-icon-wrap sc-red">
              <svg width="26" height="26" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
                <polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/>
                <line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
              </svg>
            </div>
            <h4 class="sc-title">Repository</h4>
            <p class="sc-desc">Arsip dokumen resmi dan laporan statistik yang dapat diakses publik.</p>
            <a href="/repository" class="sc-link">Lihat Dokumen →</a>
          </div>

          <div class="service-card">
            <div class="sc-icon-wrap sc-teal">
              <svg width="26" height="26" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                <line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/>
              </svg>
            </div>
            <h4 class="sc-title">Administrasi</h4>
            <p class="sc-desc">Layanan administrasi kependudukan dan surat menyurat tingkat kampung.</p>
            <a href="/layanan/administrasi-kependudukan" class="sc-link">Akses Layanan →</a>
          </div>

        </div>
      </div>
    </section>

    <!-- ======================================================
         NEWS SECTION
    ====================================================== -->
    <section class="news-section section-modern news-bg">
      <div class="container-standar">
        <div class="section-top-row">
          <div>
            <span class="section-label">Informasi Terkini</span>
            <h2 class="section-title mt-3">Berita <span>SIO Papua</span></h2>
            <p class="section-subtitle" style="margin:0;">
              Berita dan artikel seputar pembangunan dan kehidupan masyarakat Papua.
            </p>
          </div>
          <a href="/berita" class="btn-modern-outline news-cta-btn">Lihat Semua Berita</a>
        </div>

        <div class="news-grid mt-50">
          <b-link
            v-for="(berita, index) in news"
            :key="index"
            :to="'/berita/' + berita.slug"
            class="news-card-link"
          >
            <div class="news-card-modern">
              <div class="ncm-img-wrap">
                <img :src="berita.picture_path" :alt="berita.title" class="ncm-img" />
                <div class="ncm-img-overlay"></div>
                <span class="ncm-badge">Berita</span>
              </div>
              <div class="ncm-body">
                <span class="ncm-date">{{ berita.created }}</span>
                <h4 class="ncm-title">{{ berita.title | shotDescription(65) }}</h4>
                <p class="ncm-excerpt">{{ berita.content | shotDescription(115) }}</p>
                <div class="ncm-footer">
                  <div class="ncm-author">
                    <img src="@/assets/images/avatar.png" alt="Admin" class="ncm-avatar" />
                    <span>Admin</span>
                  </div>
                  <span class="ncm-read">Baca selengkapnya →</span>
                </div>
              </div>
            </div>
          </b-link>
        </div>
      </div>
    </section>

    <!-- ======================================================
         ABOUT APP SECTION
    ====================================================== -->
    <section class="about-section section-modern">
      <div class="container-standar">
        <div class="row align-items-center">

          <div class="col-lg-6 col-md-12 mb-5 mb-lg-0">
            <div class="about-video-wrap">
              <img
                src="@/assets/images/papua/misc/trigerVideo.png"
                alt="SIO Papua Video"
                class="about-video-thumb"
              />
              <button class="video-play-btn" aria-label="Play video">
                <svg width="22" height="22" fill="white" viewBox="0 0 24 24">
                  <polygon points="5 3 19 12 5 21 5 3"/>
                </svg>
              </button>
              <div class="about-video-badge">
                <span>Aplikasi Edukasi &amp; Data</span>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-md-12">
            <span class="section-label">Tentang Aplikasi</span>
            <h2 class="section-title mt-3">Aplikasi <span>SIO Papua</span></h2>
            <p class="about-desc">
              SIO Papua adalah sistem penjaring data kampung dan kelurahan di seluruh wilayah Papua.
              Dibangun untuk meningkatkan kualitas pengelolaan data dan informasi dasar kampung,
              mendukung administrasi pemerintahan, perencanaan pembangunan, dan pengembangan ekonomi kampung.
            </p>

            <div class="about-features">
              <div class="about-feat-item">
                <div class="afi-icon">
                  <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                </div>
                <span>Data terpilah OAP dan Non-OAP</span>
              </div>
              <div class="about-feat-item">
                <div class="afi-icon">
                  <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                </div>
                <span>Visualisasi data interaktif real-time</span>
              </div>
              <div class="about-feat-item">
                <div class="afi-icon">
                  <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                </div>
                <span>Akses data hingga tingkat kampung</span>
              </div>
              <div class="about-feat-item">
                <div class="afi-icon">
                  <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                </div>
                <span>Layanan administrasi digital terintegrasi</span>
              </div>
            </div>

            <div class="about-actions mt-4">
              <router-link to="/bantuan/dokumentasi" class="btn-modern-primary">
                Lihat Dokumentasi
              </router-link>
              <router-link to="/bantuan/tentangkami" class="btn-modern-outline ml-3">
                Tentang Kami
              </router-link>
            </div>
          </div>

        </div>
      </div>
    </section>

    <!-- ======================================================
         STATISTICS SECTION
    ====================================================== -->
    <section class="statistics-section section-modern statistics-bg">
      <div class="container-standar">
        <div class="text-center mb-50">
          <span class="section-label">Data Statistik</span>
          <h2 class="section-title mt-3">Statistic Progress <span>Data</span></h2>
          <p class="section-subtitle">Sinkronisasi 10 data teratas dari seluruh wilayah Papua</p>
        </div>

        <div class="stats-tabs-wrap">
          <b-tabs pills fill>
            <b-tab title="Kependudukan" active>
              <div class="tab-pane-modern">
                <div class="row">
                  <div class="col-md-4 mb-4">
                    <div class="chart-card-modern">
                      <h6 class="ccm-title">Grafik Penduduk</h6>
                      <vue-apex-charts
                        type="donut"
                        height="300"
                        :options="donutChart1.chartOptions"
                        :series="donutChart1.series"
                      />
                    </div>
                  </div>
                  <div class="col-md-8 mb-4">
                    <div class="chart-card-modern h-100">
                      <h6 class="ccm-title">Data Penduduk</h6>
                      <div class="data-rows">
                        <div class="data-row-item">
                          <span class="dri-label">Penduduk Laki-Laki</span>
                          <span class="dri-value">{{ data_penduduk.pria.semua | convertToRupiah }} Jiwa</span>
                        </div>
                        <div class="data-row-item">
                          <span class="dri-label">Penduduk Perempuan</span>
                          <span class="dri-value">{{ data_penduduk.wanita.semua | convertToRupiah }} Jiwa</span>
                        </div>
                        <div class="data-row-item">
                          <span class="dri-label">Total KK</span>
                          <span class="dri-value">{{ data_penduduk.kartu_keluarga.semua | convertToRupiah }} KK</span>
                        </div>
                        <div class="data-row-item">
                          <span class="dri-label">Total OAP</span>
                          <span class="dri-value">{{ data_penduduk.jiwa.oap | convertToRupiah }} Jiwa</span>
                        </div>
                        <div class="data-row-item">
                          <span class="dri-label">Total Non OAP</span>
                          <span class="dri-value">{{ (data_penduduk.jiwa.semua - data_penduduk.jiwa.oap) | convertToRupiah }} Jiwa</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>

            <b-tab title="Kesehatan">
              <div class="tab-pane-modern">
                <div class="row">
                  <div class="col-md-6 mb-4">
                    <div class="chart-card-modern">
                      <h6 class="ccm-title">Sumber &amp; Cara Mendapatkan Air Minum</h6>
                      <kesehatan />
                    </div>
                  </div>
                  <div class="col-md-6 mb-4">
                    <div class="chart-card-modern h-100">
                      <h6 class="ccm-title">Data Jiwa OAP dan Non OAP</h6>
                      <div class="data-rows">
                        <div class="data-row-item">
                          <span class="dri-label">Total OAP</span>
                          <span class="dri-value">{{ data_penduduk.jiwa.oap | convertToRupiah }} Jiwa</span>
                        </div>
                        <div class="data-row-item">
                          <span class="dri-label">Total Non OAP</span>
                          <span class="dri-value">{{ (data_penduduk.jiwa.semua - data_penduduk.jiwa.oap) | convertToRupiah }} Jiwa</span>
                        </div>
                        <div class="data-row-item">
                          <span class="dri-label">Total Semua</span>
                          <span class="dri-value">{{ data_penduduk.jiwa.semua | convertToRupiah }} Jiwa</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>

            <b-tab title="Pendidikan">
              <div class="tab-pane-modern">
                <div class="chart-card-modern">
                  <h6 class="ccm-title">Data Tingkat Pendidikan Terakhir</h6>
                  <Pendidikan />
                </div>
              </div>
            </b-tab>

            <b-tab title="Bansos">
              <div class="tab-pane-modern">
                <div class="chart-card-modern">
                  <h6 class="ccm-title">Data Bantuan Sosial Tahun 2022</h6>
                  <Bansos />
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </section>

    <!-- ======================================================
         CTA SECTION
    ====================================================== -->
    <section class="cta-section">
      <div class="cta-inner">
        <div class="cta-circle c1"></div>
        <div class="cta-circle c2"></div>
        <div class="container-standar cta-content">
          <div class="row align-items-center">
            <div class="col-lg-8 col-md-12 mb-4 mb-lg-0">
              <span class="cta-eyebrow">Bergabung Sekarang</span>
              <h2 class="cta-title">Akses Data Papua<br />Kapanpun, Dimanapun</h2>
              <p class="cta-subtitle">
                Masuk dan kelola data kependudukan Papua secara digital bersama SIO Papua.
              </p>
            </div>
            <div class="col-lg-4 col-md-12 text-center text-lg-right">
              <a
                href="https://admin.siopapua.papua.go.id/siopapua-login"
                class="btn-cta-white"
              >
                <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" class="mr-2">
                  <path d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" y1="12" x2="3" y2="12"/>
                </svg>
                Login Sekarang
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import JiwaSummary from "./components/JiwaSummary";
import ChartSummary from "./components/ChartSummary";
import VueApexCharts from "vue-apexcharts";
import Kesehatan from "./components/Kesehatan";
import Pendidikan from "./components/Pendidikan";
import Bansos from "./pages/data-pokok/data-kependudukan/components/bansos";

export default {
  name: "home",
  components: {
    JiwaSummary,
    ChartSummary,
    VueApexCharts,
    Kesehatan,
    Pendidikan,
    Bansos,
  },
  data() {
    return {
      data_penduduk: {
        jiwa: { oap: 0, semua: 0 },
        kartu_keluarga: { oap: 0, semua: 0 },
        pria: { oap: 0, semua: 0 },
        wanita: { oap: 0, semua: 0 },
      },
      news: [],
      donutChart1: {
        chartOptions: {
          legend: { show: false },
          labels: ["Perempuan", "Pria"],
          colors: ["#1A598C", "#4AAFFF"],
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  name: {
                    show: true,
                    fontSize: "22px",
                    fontFamily: "Inter",
                    offsetY: -10,
                  },
                  value: {
                    show: true,
                    fontSize: "16px",
                    fontFamily: "Inter, sans-serif",
                    offsetY: 16,
                    formatter: (val) => val,
                  },
                  total: {
                    show: true,
                    label: "Total",
                    color: "#373d3f",
                    formatter: (w) =>
                      w.globals.seriesTotals.reduce((a, b) => a + b, 0),
                  },
                },
              },
            },
          },
        },
        series: [444105, 493353],
      },
    };
  },
  mounted() {
    this.$store.commit("SET_BG", false);
    this.getTotalJenisPenduduk();
    this.getBerita();
  },
  methods: {
    getTotalJenisPenduduk() {
      this.$axios.get("/v1/sensus/jiwa-kk-pria-wanita").then((response) => {
        const result = response.data;
        this.data_penduduk = result;
        this.donutChart1.series = [result.wanita.semua, result.pria.semua];
      });
    },
    getBerita() {
      this.$axios.get("/news").then((response) => {
        this.news = response.data.data.filter((_, i) => i < 3);
      });
    },
  },
};
</script>
